module.exports = __webpack_public_path__ + "img/53.cb438356.jpg";